/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/arcrylic.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane020.geometry}
				material={materials.Glass}
				rotation={[-Math.PI / 2, 1.191, 0]}
			/>
		</group>
	);
}

useGLTF.preload("models/arcrylic.glb");
